// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.4-next',
  revision: '073e1cda9',
  branch: 'next',
  date: 'Wed, 17 Jun 2026 11:56:06 GMT'
};